import { booleanAttribute, Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TimelineSegment, TimelineSegmentItem } from '@splixer/player';
import { Pv3TrackInfoComponent } from '../track-info/track-info.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'pv3-segment-timeline',
  templateUrl: 'segment-timeline.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Pv3TrackInfoComponent, NgClass],
})
export class Pv3SegmentTimelineComponent {
  public timelineSegment = input<TimelineSegment | undefined>();
  public currentTrack = input<TimelineSegmentItem | undefined>(); // Current track which has yet to be pushed into the timeline segment
  public contentOnly = input(true, { transform: booleanAttribute });
  public displaySegmentInfo = input(false, { transform: booleanAttribute });
  public showAlbumArt = input(false, { transform: booleanAttribute });
  public showPlayTime = input(true, { transform: booleanAttribute });
  public trackWrapperClasses = input<string | string[] | undefined>();
}
